import { render, staticRenderFns } from "./GLABudget.vue?vue&type=template&id=d82d98da&scoped=true&"
import script from "./GLABudget.vue?vue&type=script&lang=js&"
export * from "./GLABudget.vue?vue&type=script&lang=js&"
import style0 from "./GLABudget.vue?vue&type=style&index=0&id=d82d98da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82d98da",
  null
  
)

export default component.exports